import clsx from "clsx";

import styles from "./Handler.module.css";
import { HandlerShape } from "../../types/handlerShape";

interface Props {
  big?: boolean;
  shape: HandlerShape;
  color: string;
  offset: number;
  show: boolean;
  zIndex: number;
  scale?: number;
}

export const Handler = ({
  shape,
  color,
  show,
  offset,
  zIndex,
  scale = 1,
}: Props) => {
  const style = {
    zIndex,
    transform: `translateX(${offset}px)`,
  };

  const handlerStyle = {
    background: color,
    opacity: show ? 1 : 0,
    transform: `scale(${scale})`,
  };

  const className = clsx(
    styles.handler,
    shape === HandlerShape.strip ? styles.strip : styles.circle
  );

  return (
    <div style={style} className={styles.container}>
      <div style={handlerStyle} className={className} />
    </div>
  );
};
